import type { ICustomControlData } from './TcohV1DiagnosticReportAddEditCustomControlFields';
import { FormParagraph, UserTextParagraph } from '../../../../elements/common';
import { FormLabel } from '../../../../elements/forms/FormLabel';
import { HorizontalFormGroupRead } from '../../../../elements/forms/horizontalFormGroupRead/HorizontalFormGroupRead';
import { InputContainer } from '../../../../elements/forms/InputContainer';

export function TcohV1DiagnosticReportReadCustomControlFields(props: {
    customControlData: ICustomControlData;
    isSupervising?: boolean;
    txcsProcesId: string | null;
}) {
    return (
        <>
            {props.customControlData.correlatieKlachten && (
                <HorizontalFormGroupRead>
                    <FormLabel>Correlatie klachten</FormLabel>
                    <InputContainer>
                        <FormParagraph>{props.customControlData.correlatieKlachten}</FormParagraph>
                    </InputContainer>
                </HorizontalFormGroupRead>
            )}

            {props.customControlData.afwijkingen && (
                <HorizontalFormGroupRead>
                    <FormLabel>ECG afwijkingen</FormLabel>
                    <InputContainer>
                        <FormParagraph>{props.customControlData.afwijkingen}</FormParagraph>
                    </InputContainer>
                </HorizontalFormGroupRead>
            )}

            {props.customControlData.advies && props.isSupervising && (
                <HorizontalFormGroupRead>
                    <FormLabel>Advies</FormLabel>
                    <InputContainer>
                        <UserTextParagraph>{props.customControlData.advies}</UserTextParagraph>
                    </InputContainer>
                </HorizontalFormGroupRead>
            )}
        </>
    );
}
